module.exports = __webpack_public_path__ + "static/media/hero.8a29c5cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-remodelling/hero.jpg
// module id = 62
// module chunks = 0